module.exports = __webpack_public_path__ + "static/img/manual-30.c963c2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-30.png
// module id = pMVE
// module chunks = 4